module.exports = __webpack_public_path__ + "static/media/headerlogo.4c019a7c.png";